<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
      :custom-footer-style="'position: fixed;bottom: 0px;right: 0px;background-color: var(--card-bg);width: 100%'"
    >
      <template slot="conteudo">
        <b-row
          v-if="abaAcessada == 0"
          no-gutters
        >
          <b-col class="text-right">
            <dropdown-tag
              ref="tagProposta"
              :tags="tagsProposta"
              grupo-tags="Proposta"
              legenda="Tag Proposta"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagAssinatura"
              :tags="tagsAssinatura"
              grupo-tags="Assinatura"
              legenda="Tag Assinatura"
              @enviar-pai="addTagTemplate"
            />

            <b-btn
              size="sm"
              variant="info"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="$refs.fileInput.click()"
            >
              <font-awesome-icon
                :icon="faFileUpload"
                style="font-size:15px !important;width:20px"
              /> Importar .docx
            </b-btn>

            <b-btn
              v-b-tooltip.hover.lefttop
              title="Restaurar padrão"
              size="sm"
              variant="outline-primary"
              :disabled="desabilitarEnvio"
              @click="restaurarPadrao"
            >Restaurar padrão</b-btn>
          </b-col>
        </b-row>
        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            ref="geral"
            no-body
            title="Editor de Texto"
          >
            <div
              v-if="abaAcessada == 0"
            >
              <b-row>
                <b-col>
                  <fieldset class="font-weight-bold text-muted small">
                    Aqui você customiza o template do e-mail com as ferramentas disponíveis no editor de texto
                  </fieldset>
                </b-col>
                <b-col cols="12">
                  <hr
                    class="mx-0 mt-0 mb-2"
                    style="border-top: 1px solid #a3a4a66b !important;"
                  >
                </b-col>
                <b-col cols="12">
                  <editor
                    ref="tinymceEditor"
                    v-model="form.corpoEmail"
                    api-key="rw08hrnrxbws6bwi1g8vajfilhyq7tr75s79uq8sp49np6h0"
                    :init="tinymceInit"
                    style="padding-bottom: 5%;"
                  />
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab
            no-body
            title="Perfil do Template"
          >
            <aba-parametrizacao
              v-if="abaAcessada == 1"
              ref="parametrizacao"
              titulo="Perfil do Template"
              descricao="Aqui você configura o perfil do template de e-mail; esses dados vinculam o modelo à rotina de forma automática."
              :value="form"
            />
          </b-tab>
        </b-tabs>

        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>

        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".docx"
          @change="handleDocxUpload"
        >
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.card-header{
  padding-bottom: 0px !important;
}
</style>

<script>
import Editor from '@tinymce/tinymce-vue'
import mammoth from 'mammoth'
import {
  required,
} from '@validations'
import {
  faPrint,
  faTags,
  faFileUpload,
} from '@fortawesome/free-solid-svg-icons'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import apiUsuarioInterno from '@/app-modulo/comuns/usuario-interno/shared/services/api'
import AbaParametrizacao from './ParametrizacaoTemplateEmail.vue'
import api from '../../../services/api'

export default {
  name: 'CadastroTemplate',
  components: {
    Editor,
    CadastroBase,
    AbaParametrizacao,
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  data() {
    return {
      faPrint,
      faTags,
      faFileUpload,
      required,
      form: {
        template: '',
        tipos: [],
        corpoEmail: '',
      },
      abaAcessada: 0,
      templateOptions: [
        { value: 'contrato', text: 'Contrato' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transeferencia', text: 'Proposta honorários empresas em transferência' },
      ],
      tagsProposta: ['Pessoa', 'Lista de proposta e serviços', 'Link (Clique aqui)'],
      tagsAssinatura: ['Assinatura'],
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,

      // Configuração do TinyMCE
      tinymceInit: {
        plugins: 'lists advlist link image code table wordcount autolink anchor searchreplace visualblocks fullscreen media',
        toolbar: 'undo redo | formatselect | bold italic backcolor | '
          + 'alignleft aligncenter alignright alignjustify | '
          + 'bullist numlist outdent indent | removeformat | '
          + 'link image media code table | fullscreen',
        menubar: true,
        min_height: 300,
        max_height: 700,
        entity_encoding: 'raw',
        forced_root_block: false,
      },
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    // Método para Importar DOCX (Mammoth)
    handleDocxUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const input = event.target
      input.value = null

      const reader = new FileReader()

      reader.onload = loadEvent => {
        const arrayBuffer = loadEvent.target.result

        mammoth.convertToHtml({ arrayBuffer })
          .then(result => {
            const html = result.value // O HTML convertido
            const { editor } = this.$refs.tinymceEditor

            if (editor) {
              editor.setContent(html)
              this.form.corpoEmail = html
            }
          })
          .catch(() => {
            this.$erro('Falha na conversão do arquivo DOCX.')
          })
      }

      reader.readAsArrayBuffer(file)
    },

    carregar(id) {
      api.getTemplateById(id)
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.go(-1)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        // Atualiza o model com o conteúdo do TinyMCE antes de salvar
        if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor) {
          this.form.corpoEmail = this.$refs.tinymceEditor.editor.getContent()
        }

        if (!this.form.descricao || this.form.descricao === '' || this.form.template === undefined || this.form.tipoEmail === undefined || this.form.tipos === undefined || this.form.tipos.length === 0) {
          this.$erro('Preencha os campos da aba perfil corretamente')
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Erro de validação')
        } else if (this.state === 'novo') {
          api.salvarTemplate(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTemplate(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    addTagTemplate(value) {
      // Lógica para selecionar usuário caso seja uma tag de assinatura específica
      // (Adaptado do exemplo, mantendo a lógica se futuramente adicionar tags de responsavel/testemunha no email)
      if (value.includes('{Assinatura Assinatura Responsável}') || value.includes('{Assinatura Assinatura Testemunha}')) {
        this.tagAtual = value
        if (!this.usuarios || this.usuarios.length === 0) {
          apiUsuarioInterno.getUsuariosMarcacaoDocuSign()
            .then(payload => {
              this.usuarios = payload.data
              this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
              this.$refs.modalUsuarioDocusign.show()
            })
        } else {
          this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
          this.$refs.modalUsuarioDocusign.show()
        }
      } else {
        // Inserção direta no TinyMCE
        const { editor } = this.$refs.tinymceEditor
        if (editor) {
          editor.insertContent(`<strong>${value}</strong>&nbsp;`)
        }
      }
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      const { editor } = this.$refs.tinymceEditor
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)

      if (editor) {
        editor.insertContent(`<strong>${tag}</strong>&nbsp;`)
      }

      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
    },
    restaurarPadrao() {
      if (this.form.tipoEmail === undefined) {
        this.$erro('Para restaurar o padrão é necessario selecionar o tipo de e-mail')
      } else {
        api.getPadrao(this.form.tipoEmail).then(payload => {
          this.form.corpoEmail = payload.data
          // Atualiza o editor visualmente
          if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor) {
            this.$refs.tinymceEditor.editor.setContent(payload.data)
          }
          this.$sucesso('Restaurado padrão com sucesso')
        })
          .catch(err => {
            this.$erro(err)
          })
      }
    },
  },
}
</script>
